import request from "./request";
// 获取用户信息
export const getUserDetail = (params) => {
  return request({
    url: "/user/getUserInfoById",
    params,
  });
};

// 获取授权用户信息
export const getUserInfos = (params) => {
  return request({
    url: "/weChat/student/detail",
    params,
  });
};

//更新会员用户信息
export const updateDepartmentName = (data) => {
  return request({
    url: "/user/student/update/memberInfo",
    data,
    method: "post",
  });
};

// 获取学员身份状态
export const getUserStatus = (params) => {
  return request({
    url: "/user/student/getStatus",
    params,
  });
};

// 设置播放进度
export const setViewTime = (data) => {
  return request({
    url: "/special/user/setContentView",
    data,
    method: "post",
  });
};

// 报名活动
export const applyActivity = (data) => {
  return request({
    url: "/activity/activityApply/apply",
    data,
    method: "post",
  });
};
export const getCommentsTotal = (id) => {
  return request({
    url: `/comment/getCommentCountByColumnId?columnId=${id}`,
    method: "get",
  });
};
// 一级留言列表
export const getCommentList = (params) => {
  return request({
    url: "/comment/page/student",
    params,
  });
};

// 二级留言列表
export const getCommentChildList = (params) => {
  return request({
    url: "/comment/page/student/detail",
    params,
  });
};

// 新增留言
export const publishComments = (data) => {
  return request({
    url: "/comment/add",
    data,
    method: "post",
  });
};

// 留言点赞 & 取消
export const dealCommentLike = (params) => {
  return request({
    url: "/comment/commentLike",
    params,
  });
};

// 获取某一专栏详情
export const getOneSpecialDetail = (params) => {
  return request({
    url: "/special/querySpecialColumnMini" + "/" + params.id,
    params,
  });
};

// 获取某一tab详情
export const getTabDetail = (params) => {
  return request({
    url: "/special/querySpecialContentMini" + "/" + params.id,
    params,
  });
};

// 收藏&取消收藏
export const dealCollect = (params) => {
  return request({
    url: "/collection/collectVideo",
    params,
  });
};

// 处理视频观看次数
export const dealVideoViewNum = (params) => {
  return request({
    url: "/special/user/dealCoursePlay" + "/" + params.id,
    params,
  });
};

//获取动态表单模板
export const getActiveForm = (params) => {
  return request({
    url: "/form/template/getById",
    params,
  });
};

//提交动态表单信息
export const addActiveForm = (data) => {
  return request({
    url: "/form/content/add",
    data,
    method: "post",
  });
};

//提交动态表单信息-重复提交
export const addActiveFormRepeat = (data) => {
  return request({
    url: "/form/content/addRepeatContentBase",
    data,
    method: "post",
  });
};

// 获取问卷
export const getNewQuestion = (params) => {
  return request({
    url: "/question/questionStudent/getNewQuestion",
    params,
  });
};

// 微信公众号用户是否已关注（带token查询）
export const getUserPublicSubscribe = (params) => {
  return request({
    url: "/user/getUserPublicSubscribe",
    params,
  });
};

// 生成临时二维码
export const getQRCode = (params) => {
  return request({
    url: "/weChat/getQRCode",
    params,
  });
};

// 是否有观看权限
export const getContentAuth = (params) => {
  return request({
    url: "/special/user/getContentAuth",
    params,
  });
};

// 学员开始签到
export const userStartSign = (data) => {
  return request({
    url: "/sign/userStartSign?signTaskId=" + data.signTaskId,
    data,
    method: "post",
  });
};

// 直播签到
export const userStartSignPc = (params) => {
  return request({
    url: `/sign/userStartSign`,
    method: "post",
    params,
  });
};

// 查看预约情况
export const appointmentDetail = (params) => {
  return request({
    url: "/middle/live/appointmentDetail",
    params,
    method: "get",
  });
};

// 直播预约
export const appointment = (params) => {
  return request({
    url: "/middle/live/appointment",
    params,
    method: "get",
  });
};

// 获取提交活动后弹框信息
export const getActivityDialogInfo = (params) => {
  return request({
    url: `/activity/toConfig/detail`,
    method: "get",
    params,
  });
};

// 根据relationId或者relationType查询对应直播或者视频的当前之前的推送信息。
export const queryAdvertPushAll = (params) => {
  return request({
    url: `/advertPush/queryAdvertPushAll`,
    method: "get",
    params,
  });
};

// 根据relationId或者relationType查询对应直播或者视频的当前之后的推送信息。
export const queryAdvertPushAfter = (params) => {
  return request({
    url: `/advertPush/queryAdvertPushAfter`,
    method: "get",
    params,
  });
};

export const queryAdvertOperationPushAll = (params) => {
  return request({
    url: `/advertPush/queryAdvertOperationPushAll`,
    method: "get",
    params,
  });
};

// 点击广告保存用户信息
export const addGgUserInfo = (data) => {
  return request({
    url: `/advertPushUser/add`,
    method: "post",
    data,
  });
};

// 统计学员在某个页面的停留时长
export const setUserPageStayTime = (data) => {
  return request({
    url: `/special/user/setUserPageStayTime`,
    method: "post",
    data,
  });
};

// 兑换课程
export const exchangeCourseById = ({ columnId, payPoint }) => {
  return request({
    url: "/middle/order/prepay",
    method: "post",
    data: {
      goodsId: columnId,
      payPoint,
    },
  });
};

// 脑健康会议支付并报名
export const diseasePayAndSingup = (data) => {
  return request({
    url: `/payment/order/nervous/prepay`,
    method: "post",
    data,
  });
};

// 脑健康会议支付记录
export const diseasePayOrderList = (params) => {
  return request({
    url: `/form/template/infoList`,
    method: "get",
    params,
  });
};
// 脑健康会议支付记录修改更新
export const diseasePayOrderItemUpdate = (data) => {
  return request({
    url: `/form/content/update`,
    method: "post",
    data,
  });
};

// 脑健康提交预报名表单
export const submitJustSignUpForm = (data) => {
  return request({
    url: `/payment/order/nervous/preNoPay`,
    method: "post",
    data,
  });
};

// 支付脑健康提交预报名表单
export const payHaveSignUpRecord = (data) => {
  return request({
    url: `/form/content/update`,
    method: "post",
    data,
  });
};

// 播放页分享
export const addShareCollect = (data) => {
  return request({
    url: `/collection/addCollect`,
    method: "post",
    data,
  });
};

// 添加用户网页浏览记录
export const addPageBrowserRecord = (data) => {
  return request({
    url: `/user/addPageBrowserRecord`,
    method: "post",
    data,
  });
};

// 记录生成海报用户
export const setUserViewsRecords = (data) => {
  return request({
    url: "/user/addPageBrowserRecord",
    method: "post",
    data,
  });
};

// 获取用户当前播放相关推荐
export const getRecommendListBySize = (params) => {
  return request({
    url: "/special/recommend/list",
    method: "get",
    params,
  });
};

//视解析页面
export const getcourseDetailbyId = (params) => {
  return request({
    url: `/tingwu/newFrontCourseDetail/${params.id}`,
    method: "get",
    params,
  });
};

export const getCourseDetail = (params) => {
  return request({
    url: `/tingwu/courseDetail/${params.id}`,
    method: "get",
    params,
  });
};

//获取视频
export const getcoursebyId = (params) => {
  return request({
    url: `/tingwu/courseFile/${params.id}`,
    method: "get",
    params,
  });
};

// 播放进度
export const setContentView = (data) => {
  return request({
    url: `/special/user/setContentView`,
    method: "post",
    data,
  });
};

// 分页获取ai课程的病例
export const getAiCourseCaseByPage = (params) => {
  return request({
    url: "/tingwu/frontCourseCaseManagePage",
    params,
  });
};

// 分页获取ai课程的栏目内容
export const getAiCourseColumnPage = (params) => {
  return request({
    url: "/tingwu/frontCourseColumnPage",
    params,
  });
};

// 根据id获取随堂练习
export const getExDetail = (params) => {
  return request({
    url: "/middle/normal/course/exercise/detail",
    params,
  });
};

// 提交随堂练习
export const submitStlx = (data) => {
  return request({
    url: `/middle/normal/course/exercise/user/submit`,
    method: "post",
    data,
  });
};

// 获取直播大会信息
export const getMeetingConfig = (id) => {
  return request({
    url: `/conference/user/home/config?id=${id}`,
  });
};

// 根据id获取推荐会议列表
export const pediatricsPreConferenceList = (params) => {
  return request({
    url: `/special/recommend/pediatricsPreConferenceList/${params.id}`,
    params,
  });
};

// 直播聊天室
// 获取发言列表
export const getchatList = (params) => {
  return request({
    url: `/chat/user/chatList`,
    params,
  });
};

// 发言
export const submitChat = (data) => {
  return request({
    url: `/chat/user/submit`,
    method: "post",
    data,
  });
};

// 是否已收藏
export const queryCollect = (data) => {
  return request({
    url: `/collection/queryCollect`,
    method: "post",
    data,
  });
};

// 收藏
export const addCollect = (data) => {
  return request({
    url: `/collection/addCollect`,
    method: "post",
    data,
  });
};
// 取消收藏
export const cancelCollect = (data) => {
  return request({
    url: `/collection/cancelCollect`,
    method: "post",
    data,
  });
};

// 收藏列表
export const collectPage = (data) => {
  return request({
    url: `/collection/queryCollectPage`,
    method: "post",
    data,
  });
};

// 检查用户是否购买了课程
export const getCourseUserPower = (params) => {
  return request({
    url: `/orderRelation/getCourseUserPower`,
    params,
  });
};

// 查询课程是否绑定商品
export const getCourseBindProduct = (params) => {
  return request({
    url: `/orderRelation/getGoodsCourseDetail`,
    params,
  });
};

// 获取评分视频列表
export const scoreplayApi = (id) => {
  return request({
    url: `/special/scorePlay/${id}`,
  });
};
// 提交评分
export const scoresubmitApi = (data) => {
  return request({
    url: `/scoring/submit`,
    method: "post",
    data,
  });
};
